import { SelectorOptionMap } from './Selector';
import { useMemo } from 'react';
import { InternalApiListSelectorOption } from '../../../api-internal';
import { ManualCustomListSelectorCode } from './ListGroups';

interface Props {
  selectorOptionMap: SelectorOptionMap;
}

export const useGroupSummary = ({ selectorOptionMap }: Props) => {
  const groupSummary = useMemo(() => {
    return getGroupSummary(selectorOptionMap);
  }, [selectorOptionMap]);

  return {
    groupSummary,
    getAllGroupSummary,
  };
};

interface GroupSummary {
  enabledSelectorOptions: string[];
  subscribedSelectorOptions: string[];
}

const getGroupSummary = (optionMap: SelectorOptionMap): GroupSummary => {
  return {
    enabledSelectorOptions: [...optionMap.values()].filter((option) => option.isSelected).map((option) => option.value),
    subscribedSelectorOptions: [...optionMap.values()]
      .filter((option) => option.isSubscribed)
      .map((option) => option.value),
  };
};

// Add both DJ PERSON and ENTITY Reference Codes
const getAllGroupSummary = (
  selectorOptionMap: SelectorOptionMap,
  apiSelectorOptions: InternalApiListSelectorOption[],
  type: ManualCustomListSelectorCode
): GroupSummary => {
  if (type !== ManualCustomListSelectorCode.DJ_SANCTION_LISTS) {
    return getGroupSummary(selectorOptionMap);
  }

  const selectorOptionMapValues = [...selectorOptionMap.values()];

  // TODO This assumes that all programs are unique!!!
  const enabledSelectorTitles = selectorOptionMapValues
    .filter((option) => option.isSelected)
    .map((option) => option.title);

  const agnosticSubscribedSelectorValues = selectorOptionMapValues
    .filter((option) => option.isSubscribed)
    .map((option) => option.value.replace(/^PERSON\./i, ''));

  return {
    enabledSelectorOptions: apiSelectorOptions
      .filter((apiOption) => enabledSelectorTitles.includes(apiOption.descriptions[0]))
      .map((apiOption) => apiOption.value),
    subscribedSelectorOptions: apiSelectorOptions
      .filter((apiOption) => {
        const agnosticApiOption = apiOption.value.replace(/^PERSON\.|^ENTITY\./i, '');
        return agnosticSubscribedSelectorValues.includes(agnosticApiOption);
      })
      .map((apiOption) => apiOption.value),
  };
};
